import { Grid, Box, IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { type ReferralData } from 'Pages/Referral/ReferralDetail'
import { FormatCurrency, FormatDateValue } from 'core/Utilities'

export interface EnrollmentHeaderProps {
  enrollment: ReferralData
  hideEditButtons: boolean
  onEdit: (show: boolean) => void
}

export function EnrollmentHeader (props: EnrollmentHeaderProps): JSX.Element {
  return <>
    <Grid container columns={2} spacing={2} sx={{ paddingTop: '10px' }}>
      <Grid container item spacing={1} xs={6}>
        <Box className='valid-status'>
          {props.enrollment.status}
        </Box>
      </Grid>
      <Grid item container spacing={1} xs={5} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box className='valid-status'>
          {props.enrollment.sessionBlockName}
        </Box>
      </Grid>
      <Grid item container xs={1} sx={{ pt: '0px !important' }}>
        {!props.hideEditButtons && (
          <Box><IconButton data-testid='referralEditButton' onClick={() => { props.onEdit(true) }}><EditIcon /></IconButton></Box>
        )}
      </Grid>

      <Grid container item spacing={1} xs={6} sx={{ height: 'fit-content' }} >
        {props.enrollment.status === 'Waitlist' &&
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
            <Box>Waitlist date</Box>
            <Box >{FormatDateValue(props.enrollment.waitlistDate)}</Box>
          </Grid>
        }
        {(props.enrollment.status === 'Enrolled' || props.enrollment.status === 'Exited') &&
          <>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
              <Box>Enrolled on</Box>
              <Box >{FormatDateValue(props.enrollment.enrollmentDate)}</Box>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
              <Box>Start date</Box>
              <Box >{FormatDateValue(props.enrollment.startDate)}</Box>
            </Grid>
          </>
        }
        {props.enrollment.status === 'Exited' &&
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
            <Box>End date:</Box>
            <Box >{FormatDateValue(props.enrollment.endDate)}</Box>
          </Grid>
        }

        {props.enrollment.incomeApproved !== 'NotApplicable' && <>
          <Grid item xs={12}><hr style={{ margin: '0' }} /></Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} data-testid='verifiedIncome'>
            <Box>Verified Income</Box>
            <Box sx={{ fontWeight: 'bold' }}>{FormatCurrency(props.enrollment.verifiedIncome)}</Box>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} data-testid='povertyLevel'>
            <Box>Poverty Level</Box>
            <Box sx={{ color: 'lightseagreen' }}>{props.enrollment.povertyPercent}{props.enrollment.povertyPercent !== null ? '%' : ''}</Box>
          </Grid>
        </>
        }
      </Grid>
      <Grid container item spacing={1} xs={6} sx={{ height: 'fit-content' }}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
          {props.enrollment.desiredSchedule}
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
          {props.enrollment.facilityName}
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
          {props.enrollment.sessionName}
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
          {props.enrollment.programName}
        </Grid>
      </Grid>
    </Grid>
  </>
}
